import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {getNoData} from "../../items/index.js";
import * as constants from "../../widgetConstants.js";
import {AJAX_OPTION} from "../../../../util/Ajax.js";
import Widget from "../widget.js";
import {readTargetRecord} from "../../../../indexedDB/index.js";
import {clickMemberWidget} from "./event.js";
import {getMembersHtmByRecord} from "./item.js";
import u from "../../../../util/index.js";

const TYPE = [
    'RECENT',
    'COUNT',
    'ALL'
]

export class MemberWidget extends Widget {

    async setup(props) {
        return super.setup(props);
    }

    async getData() {
        let inputData = {}
        if (Number(this.$props.FIL_END_DT_GUBUN) === 3) {
            inputData = {
                ...this.$props.pageData,
                SRCH_GB: 'FLNM',
                USER_ID: _USER_ID,
                RGSR_ID: _USER_ID,
                USE_INTT_ID: _USE_INTT_ID,
            }
        } else {
            inputData = {
                GUBUN: this.$props.FIL_END_DT_GUBUN ? TYPE[this.$props.FIL_END_DT_GUBUN - 1] : TYPE[0],
                SEARCH_WEEK: '2',
                USER_ID: _USER_ID,
                RGSR_ID: _USER_ID,
                USE_INTT_ID: _USE_INTT_ID,
            }
        }
        return await super.checkDataVersion(inputData)
    }

    async getDBData(inputData) {
        const data = await DashboardApi.getApi(this.$props.API_KEY, inputData, AJAX_OPTION.ALLOW_EXECUTE)
        this.$props.pageData.NEXT_YN = u.n2v(data.NEXT_YN, "N");

        return {recordData: data[this.$props.RECORD]};
    }

    async render() {
        $(this.$target).html('')
        $(this.$target).drawListHelper({
            pageData: this.$props.pageData,
            nextYn: this.$props.pageData.NEXT_YN,
            records: this.$props.data,
            noDataHtml: getNoData('member'),
            callback: {
                scroll: () => {
                    this.setup.bind(this)({
                        isDataDrivenRendering: true,
                        isScrolling : true,
                    })                },
                item: getMembersHtmByRecord,
                final: this.mounted.bind(this)
            }
        })
    }

    mounted() {
        super.mounted();

        const $t = $(this.$target);
        if ($t.find('.js-member-invite').length === 0
            && this.$props.data?.length > 0
            && _USE_INTT_ID.indexOf('UTLZ') === -1
        ) {
            $t.prepend(`<li class="js-member-invite widget-default">
                            <span class="member-box"></span>
                            <span class="prj-title">${i18next.t(main.inviteEmployee.inviteEmployee)}</span>
                        </li>`)
        }

        // 구성원 - 전체 옵션이 아닌 경우 페이징 처리를 하지 않는다.
        if(Number(this.$props.FIL_END_DT_GUBUN) !== 3){
            this.$props.pageData.NEXT_YN = 'N'
        }

        $t.find('.widget-article-list').removeClass('dash-pending')
        $t.find('.dash-num-pending').remove()

    }

    setEvent() {
        const $w = $(this.$target).closest('.widget-my-member');
        $w.off('click').on('click', (e) => clickMemberWidget(e, this))
    }

}

